import BettingPromotions from './BettingPromotions.vue';
import BettingPromotionsList from './BettingPromotionsList.vue';
import state from './state/BettingPromotions';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default { BettingPromotions, BettingPromotionsList, state };
